//
import SlSaleInvoiceModel from '@/models/Sale/SlSaleInvoice'

//
export default class SlSaleInvoiceService {

  /**
   * 
   */
  static getByNumber(number) {
    return this
      .model()
      .from()
      .many('number/' + number)
      .include(
        'sl_customer', 
        'sl_detail_sale_invoices.wh_product', 
        'first_pos_sale'
      )
      .get()
  }

  /**
   *  Returns the model
   */
  static model() {
    return SlSaleInvoiceModel
  }
}